export class ZIDXFormFieldValue {
    label;
    value;
    constructor(label:string, value:string){
        this.label=label;
        this.value=value;
    }
}
